<template>
  <v-card
    class="b-1 b-radius-8"
    data-testid="dashboard-family-subsidy-program"
  >
    <v-card-title>
      <v-row>
        <v-col class="d-flex align-center">
          <div>
            <h3 class="fs-20">
              {{ $bct(familySubsidyProgram.name) }}
            </h3>
          </div>
        </v-col>
      </v-row>
    </v-card-title>

    <v-divider />

    <template v-if="familySubsidyProgram.description">
      <v-card-text>
        <p>{{ $bct(familySubsidyProgram.description) }}</p>
      </v-card-text>

      <v-divider />
    </template>

    <v-card-actions>
      <v-spacer />
      <v-btn
        @click="createFamilySubsidy"
        :loading="processing"
        class="fs-16"
        color="primary"
        role="link"
      >
        {{ $bct(familySubsidyProgram.has_applied ? 'Reapply' : 'Start application') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
const props = defineProps({
  familySubsidyProgram: {
    type: Object,
    required: true,
  },
  processing: {
    type: Boolean,
  },
});

const emit = defineEmits(['create']);

const $bct = inject('translator');

function createFamilySubsidy() {
  emit('create', props.familySubsidyProgram);
}
</script>
